// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"511b568b6f081adc6ab9","339":"5dfd87665d54aa7c3b27"}[chunkId] + ".js";
};